import { render, staticRenderFns } from "./dataApi.vue?vue&type=template&id=105e7ea4&scoped=true&"
import script from "./dataApi.vue?vue&type=script&lang=js&"
export * from "./dataApi.vue?vue&type=script&lang=js&"
import style0 from "./dataApi.vue?vue&type=style&index=0&id=105e7ea4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "105e7ea4",
  null
  
)

export default component.exports